import ReactGA from 'react-ga';
const TRACKING_ID =  process.env.NODE_ENV === 'production' ? 'UA-35583129-1' : 'UA-35583129-4'

const sendWhoIsAccessing = (userEmail) => {
  ReactGA.initialize(TRACKING_ID)
  var ga = ReactGA.ga()
  ga('send', 'event', 'Login', 'Login Success', window.location.origin, {
    dimension1 : userEmail,
    dimension2 : window.location.origin
  })
}

const fireTracking = () => {
    ReactGA.initialize(TRACKING_ID)
    ReactGA.pageview(window.location.pathname + window.location.search);
}

export default {
  fireTracking,
  sendWhoIsAccessing
}



// WEBPACK FOOTER //
// ./src/utils/googleAnalytics.js